import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOrderMSDocumentListData } from './mockData'
import type { IOrderMSDocument } from '~/types/document/models'

export const {
  getDocuments: getOrderMSDocuments,
  postDocument: postOrderMSDocument,
  patchDocument: patchOrderMSDocument,
  deleteDocument: deleteOrderMSDocument,
  handlers,
} = makeDocumentAPIs<IOrderMSDocument>({
  apiPathEntityNamePrefix: 'orderms',
  getDocumentListDataFn: getOrderMSDocumentListData,
})
